import { canvasImgAnimatedTpl } from './canvasImgAnimated';
export { canvasImgAnimatedTpl }